import { Navigate, useParams } from 'react-router-dom'
import DimensionPageTemplate from '../../components/dimensions/DimensionPageTemplate'
import { getDimensionContent } from '../../data/dimensionsContent'

export default function DimensionPage() {
  const { slug } = useParams()
  const data = getDimensionContent(slug)

  if (!data) {
    return <Navigate to="/" replace />
  }

  return <DimensionPageTemplate data={data} />
}
